import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacity,
    KeyboardAvoidingView,
    ImageBackground,
    ActivityIndicator, Linking, Image
} from "react-native";


import Colors from "../../../tools/Colors";
import PathFile from "../../../assets/PathFile";
import HMTextView from "../../../customviews/HMTextView";
import HMActionBar from "../../../customviews/HMActionBar";
import i18n from "../../../I18n/i18n";
import {moderateScale} from "../../../tools/Scaling";
import {typeExport} from "../../../redux/store/type";

const SLIDER_1_FIRST_ITEM = 1;


export default class ShahrbanSatiaScreen extends Component {


    constructor(props) {
        super(props);

        this.state = {
            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,

            modalHeight: 0,
            ddd: [
                "The min size must be a number.",
                "The min size must be less than 4.",
                "The max size must be a number."
            ]

        };

    }

    componentWillReceiveProps(propss) {

    }

    showDialogUpdateApp() {
        this.setState({showDialogUpdateAppCustomize: true})
    }

    componentDidMount() {


    }

    componentWillUnmount() {
        //Tools._RemoveConnectivity()
    }


    render() {
        let phone = "08633805"
        let linkUrlahvaz = "http://ahvaz.ir"
        let linkUrl137yar = "http://137yar.ahvaz.ir"
        let linkUrlfanahvaz = "http://ict.ahvaz.ir"
        let linkUrlsatia = "http://iran137.com/"

        return (
            <View style={{flex: 1}}>
                <HMActionBar back menu props={this.props} statusBarTransparent text={i18n.t('constant.About_software')}
                             headerVisibility
                             more_menu
                             drawer
                             onBackPress={() => this.props.navigation.pop()}/>
                <View style={{position: 'relative', flex: 1, alignItems: 'center', backgroundColor: '#156ef9'}}>

                    <ScrollView>

                        <View style={{flex: 1, alignItems: 'center'}}>
                            <Image
                                //   resizeMode={'stretch'}
                                style={{
                                    //    width: typeExport.WIDTH-moderateScale(25),
                                    width: typeExport.WIDTH / 6,
                                    height: typeExport.WIDTH / 6,

                                }}
                                source={PathFile.image.logoShahrdariAhvaz}

                                // source={ background ? background :PathFile.image.background}
                                //   source={ background ? background :PathFile.image.background}
                                //   source={ background ? background :null}

                                //  source={this.props.DataSplashScreen.Background !== null ? {uri:this.props.DataSplashScreen.Background }: PathFile.image.background}
                            />
                            <Image
                                //   resizeMode={'stretch'}
                                style={{
                                    //    width: typeExport.WIDTH-moderateScale(25),
                                    width: typeExport.WIDTH / 4,
                                    height: typeExport.WIDTH / 9,

                                }}
                                source={PathFile.image.shahrdariAhvazText}

                            />

                            <TouchableOpacity
                                style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',
                                    margin: moderateScale(3),
                                    marginBottom: moderateScale(18)
                                }}

                                onPress={() => {
                                    Linking.openURL(linkUrlahvaz).catch(err => console.error('An error occurred', err))

                                }}

                            >
                                <HMTextView
                                    text={linkUrlahvaz}
                                    // text={"امیر علی اکبری متولد سال ۱۳۶۶، قهرمان حال حاضر سنگین وزن مسابقات mma و قهرمان سابق کشتی فرنگی جهان می‌باشد."}

                                    type={'bold'}
                                    style={{
                                        // alignSelf: 'center',
                                        //  marginRight: moderateScale(6),
                                        // margin: moderateScale(6),
                                        //  textAlign: 'center',
                                        color: Colors.white,
                                        fontSize: moderateScale(15),
                                    }}/>
                            </TouchableOpacity>


                            <Image
                                //   resizeMode={'stretch'}
                                style={{
                                    //    width: typeExport.WIDTH-moderateScale(25),
                                    width: typeExport.WIDTH / 1.3 - moderateScale(25),
                                    height: typeExport.WIDTH / 1.9,

                                }}
                                source={PathFile.image.logoFava}

                            />


                            <TouchableOpacity
                                style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',
                                    margin: moderateScale(3),
                                    marginBottom: moderateScale(10)
                                }}

                                onPress={() => {
                                    Linking.openURL(linkUrlfanahvaz).catch(err => console.error('An error occurred', err))

                                }}

                            >
                                <HMTextView
                                    text={linkUrlfanahvaz}
                                    // text={"امیر علی اکبری متولد سال ۱۳۶۶، قهرمان حال حاضر سنگین وزن مسابقات mma و قهرمان سابق کشتی فرنگی جهان می‌باشد."}

                                    type={'bold'}
                                    style={{
                                        // alignSelf: 'center',
                                        //  marginRight: moderateScale(6),
                                        // margin: moderateScale(6),
                                        //  textAlign: 'center',
                                        color: Colors.white,
                                        fontSize: moderateScale(15),
                                    }}/>
                            </TouchableOpacity>


                            <View
                                style={{
                                    marginTop: moderateScale(24),
                                    alignItems: 'center',
                                    justifyContent: "center",
                                }}>

                                {/*             <HMTextView
                                text={"شهرداری اهواز - تلفن روابط عمومی:"}
                                // text={"امیر علی اکبری متولد سال ۱۳۶۶، قهرمان حال حاضر سنگین وزن مسابقات mma و قهرمان سابق کشتی فرنگی جهان می‌باشد."}

                                type={'bold'}
                                style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',

                                    color: Colors.blackLight,
                                    fontSize: moderateScale(15),

                                }}/>
                            <View style={{width: moderateScale(3)}}/>*/}
                                <View style={{alignItems: 'center', marginBottom: moderateScale(15)}}>
                                    {/*       <TouchableOpacity

                                    style={{
                                        margin: moderateScale(3),
                                        //  height:moderateScale(20)
                                    }}
                                    onPress={() => {
                                        const url = Platform.OS === 'ios' ? `telprompt:06133335063` : `tel://06133335063`;
                                        Linking.canOpenURL(url)
                                            .then((supported) => {
                                                if (supported) {
                                                    return Linking.openURL(url)
                                                        .catch(() => null);
                                                }
                                            });
                                    }}
                                >
                                    <HMTextView
                                        text={"06133335063"}
                                        // text={"امیر علی اکبری متولد سال ۱۳۶۶، قهرمان حال حاضر سنگین وزن مسابقات mma و قهرمان سابق کشتی فرنگی جهان می‌باشد."}

                                        type={'bold'}
                                        style={{
                                            // alignSelf: 'center',
                                            //  marginRight: moderateScale(6),
                                            // margin: moderateScale(6),
                                            //  textAlign: 'center',

                                            color: Colors.red,
                                            fontSize: moderateScale(15),

                                        }}/>
                                </TouchableOpacity>
                                <HMTextView
                                    text={"  _  "}
                                    // text={"امیر علی اکبری متولد سال ۱۳۶۶، قهرمان حال حاضر سنگین وزن مسابقات mma و قهرمان سابق کشتی فرنگی جهان می‌باشد."}

                                    type={'bold'}
                                    style={{
                                        // alignSelf: 'center',
                                        //  marginRight: moderateScale(6),
                                        // margin: moderateScale(6),
                                        //  textAlign: 'center',

                                        color: Colors.red,
                                        fontSize: moderateScale(16),

                                    }}/>*/}
                                    {/* <TouchableOpacity
                                    style={{
                                        // alignSelf: 'center',
                                        //  marginRight: moderateScale(6),
                                        // margin: moderateScale(6),
                                        //  textAlign: 'center',
                                        margin: moderateScale(3)
                                    }}

                                    onPress={() => {
                                       // Linking.openURL("http://ict.ahvaz.ir").catch(err => console.error('An error occurred', err))

                                    }}

                                >
                                    <HMTextView
                                        text={"سامانه مدیریت درخواستهای 137"}
                                        // text={"امیر علی اکبری متولد سال ۱۳۶۶، قهرمان حال حاضر سنگین وزن مسابقات mma و قهرمان سابق کشتی فرنگی جهان می‌باشد."}

                                        type={'bold'}
                                        style={{
                                            // alignSelf: 'center',
                                            //  marginRight: moderateScale(6),
                                            // margin: moderateScale(6),
                                            //  textAlign: 'center',
                                            color: Colors.white,
                                            fontSize: moderateScale(15),
                                        }}/>
                                </TouchableOpacity>*/}
                                    <Image
                                        //   resizeMode={'stretch'}
                                        style={{
                                            //    width: typeExport.WIDTH-moderateScale(25),
                                            width: typeExport.WIDTH / 1.8,
                                            height: typeExport.WIDTH / 8,

                                        }}
                                        source={PathFile.image.samanehText}

                                        // source={ background ? background :PathFile.image.background}
                                        //   source={ background ? background :PathFile.image.background}
                                        //   source={ background ? background :null}

                                        //  source={this.props.DataSplashScreen.Background !== null ? {uri:this.props.DataSplashScreen.Background }: PathFile.image.background}
                                    />
                                    <TouchableOpacity
                                        style={{
                                            // alignSelf: 'center',
                                            //  marginRight: moderateScale(6),
                                            // margin: moderateScale(6),
                                            //  textAlign: 'center',
                                            margin: moderateScale(3)
                                        }}

                                        onPress={() => {
                                            Linking.openURL(linkUrl137yar).catch(err => console.error('An error occurred', err))

                                        }}

                                    >
                                        <HMTextView
                                            text={linkUrl137yar}
                                            // text={"امیر علی اکبری متولد سال ۱۳۶۶، قهرمان حال حاضر سنگین وزن مسابقات mma و قهرمان سابق کشتی فرنگی جهان می‌باشد."}

                                            type={'bold'}
                                            style={{
                                                // alignSelf: 'center',
                                                //  marginRight: moderateScale(6),
                                                // margin: moderateScale(6),
                                                //  textAlign: 'center',
                                                color: Colors.white,
                                                fontSize: moderateScale(15),
                                            }}/>
                                    </TouchableOpacity>
                                </View>
                                <View style={{height: moderateScale(6)}}/>

                            </View>


                            <HMTextView
                                text={i18n.t('constant.ContractorSatiaCompany')}
                                // text={"امیر علی اکبری متولد سال ۱۳۶۶، قهرمان حال حاضر سنگین وزن مسابقات mma و قهرمان سابق کشتی فرنگی جهان می‌باشد."}

                                type={'bold'}
                                style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',

                                    color: "#fecf33",
                                    fontSize: moderateScale(18),

                                }}/>


                            <TouchableOpacity
                                style={{
                                    // alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    //  textAlign: 'center',
                                    //   margin: moderateScale(3),
                                    marginBottom: moderateScale(20)
                                }}

                                onPress={() => {
                                    Linking.openURL(linkUrlsatia).catch(err => console.error('An error occurred', err))

                                }}

                            >
                                <HMTextView
                                    text={linkUrlsatia}
                                    // text={"امیر علی اکبری متولد سال ۱۳۶۶، قهرمان حال حاضر سنگین وزن مسابقات mma و قهرمان سابق کشتی فرنگی جهان می‌باشد."}

                                    type={'bold'}
                                    style={{
                                        // alignSelf: 'center',
                                        //  marginRight: moderateScale(6),
                                        // margin: moderateScale(6),
                                        //  textAlign: 'center',
                                        color: Colors.white,
                                        fontSize: moderateScale(16),
                                        marginTop: moderateScale(6)
                                    }}/>
                            </TouchableOpacity>
                            <Image
                                //   resizeMode={'stretch'}
                                style={{
                                    //    width: typeExport.WIDTH-moderateScale(25),
                                    width: typeExport.WIDTH / 5,
                                    height: typeExport.WIDTH / 10,


                                    marginBottom: moderateScale(20)
                                }}
                                source={PathFile.image.satiaWifi}

                                // source={ background ? background :PathFile.image.background}
                                //   source={ background ? background :PathFile.image.background}
                                //   source={ background ? background :null}

                                //  source={this.props.DataSplashScreen.Background !== null ? {uri:this.props.DataSplashScreen.Background }: PathFile.image.background}
                            />
                        </View>
                    </ScrollView>


                </View>

            </View>
        );
    }


}
